'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MPPHeaderRoot = require('./MPPHeaderRoot');

var _MPPHeaderRoot2 = _interopRequireDefault(_MPPHeaderRoot);

var _MPPHeaderDefaultProps = require('../components/MPPHeaderDefaultProps');

var _MPPHeaderDefaultProps2 = _interopRequireDefault(_MPPHeaderDefaultProps);

var _MPPHeaderPropTypes = require('../components/MPPHeaderPropTypes');

var _MPPHeaderPropTypes2 = _interopRequireDefault(_MPPHeaderPropTypes);

var _breakpoints = require('../../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropdownLinks = [];
var hoverCloseDelay = 500;

var GlobalHeader = function (_Component) {
  _inherits(GlobalHeader, _Component);

  function GlobalHeader(props) {
    _classCallCheck(this, GlobalHeader);

    var _this = _possibleConstructorReturn(this, (GlobalHeader.__proto__ || Object.getPrototypeOf(GlobalHeader)).call(this, props));

    _this.registerDropDown = function (elemRef) {
      return dropdownLinks.push(elemRef) - 1;
    };

    _this.handleMainLinks = _this.handleMainLinks.bind(_this);
    _this.openHeader = _this.openHeader.bind(_this);
    _this.closeHeader = _this.closeHeader.bind(_this);
    _this.openSubnav = _this.openSubnav.bind(_this);
    _this.closeSubnav = _this.closeSubnav.bind(_this);
    _this.handleMenuButton = _this.handleMenuButton.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleOrientationChange = _this.handleOrientationChange.bind(_this);
    _this.handleMainLinksHover = _this.handleMainLinksHover.bind(_this);
    _this.handleSubNavHover = _this.handleSubNavHover.bind(_this);
    _this.processStickyState = _this.processStickyState.bind(_this);
    _this.processFixedStyleState = _this.processFixedStyleState.bind(_this);
    _this.headerRef = undefined;
    _this.bodyRef = undefined;
    _this.bodyClassNameWhenOpen = 'menu-open' + (props.config.rtl ? '-rtl' : '');
    _this.hoverLinkTimeOut = undefined;
    _this.state = {
      isHeaderFixed: true,
      isOpen: false,
      isClosing: false,
      isSticky: false,
      isHeaderOpen: false,
      fixedStyles: _this.isWhiteThemeSet(),
      activeLink: undefined,
      closingLinkIndex: -1,
      activeLinkIndex: -1,
      currentWindowWidth: 0,
      scrollY: 0
    };
    return _this;
  }

  _createClass(GlobalHeader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        this.setState({
          currentWindowWidth: window.innerWidth
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('orientationchange', this.handleOrientationChange);
      document.addEventListener('keydown', this.handleKeyDown);

      this.handleOrientationChange();
      this.handleResize();
      this.handleScroll();
      this.setBodyRef();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('orientationchange', this.handleOrientationChange);
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'setBodyRef',
    value: function setBodyRef() {
      /*
      * This method is used to find the closest BODY parent to the header
      * and is needed since we need to append a class to the body in order to
      * target all the elements via css to translate them when the menu is opened
      * This will work in every browser, as well as in iframes
      */
      var currentRef = this.headerRef.parentNode;
      while (!this.bodyRef && currentRef) {
        if (currentRef.tagName === 'BODY') {
          this.bodyRef = currentRef;
        } else {
          currentRef = currentRef.parentNode;
        }
      }
      this.bodyRef = this.bodyRef || document.body;
    }
  }, {
    key: 'isScrollYTruthy',
    value: function isScrollYTruthy(e) {
      // TODO: Remove this pb hack once we have a better solution
      if (e && e.iFrameScrollY !== undefined) {
        this.iFrameScrollY = e.iFrameScrollY;
      }
      return (window.scrollY || window.pageYOffset || this.iFrameScrollY) > 0;
    }
  }, {
    key: 'isWhiteThemeSet',
    value: function isWhiteThemeSet() {
      return this.props.config.theme === 'theme-background-color-white';
    }
  }, {
    key: 'handleCloseFixedStyles',
    value: function handleCloseFixedStyles() {
      if (this.state.isSticky) {
        return true;
      }
      return this.isWhiteThemeSet();
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode !== 27) {
        return;
      }
      if (this.state.activeLink) {
        this.closeSubnav(event);
        return;
      }
      if (this.state.isOpen) {
        this.handleMenuButton();
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      var _this2 = this;

      // TODO: Explore different solution to trigger resize
      // inside an iFrame; We don't need this event
      // param; it's only for page-builder
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth;
      var windowWidthChanged = newWindowWidth !== this.state.currentWindowWidth;
      if (windowWidthChanged && (this.state.isOpen || this.state.activeLink)) {
        this.bodyRef.classList.remove(this.bodyClassNameWhenOpen, 'fixed-open');

        this.setState({
          isOpen: false,
          isClosing: true,
          activeLink: undefined,
          activeLinkIndex: -1,
          currentWindowWidth: newWindowWidth,
          isHeaderOpen: false
        });
        setTimeout(function () {
          _this2.setState({
            isClosing: false
          });
        }, 400);
      }
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(e) {
      // Prevent scrolling only if header isOpen
      if (this.state.isOpen) {
        e.preventDefault();
        return false;
      }
      return true;
    }
  }, {
    key: 'handleOrientationChange',
    value: function handleOrientationChange() {
      if (window.orientation !== undefined && window.orientation !== 0) {
        window.removeEventListener('touchmove', this.handleTouchMove);
        // Remove all style and all fixed properties from header
        this.setState({
          isHeaderFixed: window.innerWidth >= _breakpoints2.default.large,
          scrollY: 0,
          fixedStyles: this.handleCloseFixedStyles()
        });
      } else {
        window.addEventListener('touchmove', this.handleTouchMove);
        this.setState({
          isHeaderFixed: true
        });
      }
    }
  }, {
    key: 'processFixedStyleState',
    value: function processFixedStyleState(e) {
      var fixedStyles = true;
      if (this.isScrollYTruthy(e)) {
        if (this.state.isHeaderOpen || !this.state.isHeaderFixed) {
          fixedStyles = false;
        }
      } else {
        fixedStyles = false;
      }
      return {
        fixedStyles: fixedStyles
      };
    }
  }, {
    key: 'processStickyState',
    value: function processStickyState(e) {
      if (this.isScrollYTruthy(e)) {
        return {
          isSticky: true
        };
      }
      return {
        isSticky: false
      };
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(e) {
      var functionsArr = [{}, this.processStickyState];
      if (!this.isWhiteThemeSet()) {
        functionsArr.push(this.processFixedStyleState);
      }
      var finalState = functionsArr.reduce(function (nextState, nextFunc) {
        return Object.assign({}, nextState, nextFunc(e));
      });
      this.setState(finalState);
    }
  }, {
    key: 'closeHeader',
    value: function closeHeader() {
      this.setState({
        isOpen: false,
        activeLink: undefined,
        activeLinkIndex: -1,
        isHeaderOpen: false
      });
    }
  }, {
    key: 'openHeader',
    value: function openHeader() {
      this.setState({
        isOpen: true,
        activeLink: undefined,
        activeLinkIndex: -1,
        isHeaderOpen: true,
        scrollY: window.scrollY || window.pageYOffset || this.iFrameScrollY
      });
    }
  }, {
    key: 'closeSubnav',
    value: function closeSubnav(event) {
      var _this3 = this;

      if (event) {
        event.preventDefault();
      }
      this.setState({
        isClosing: true,
        activeLink: undefined,
        closingLinkIndex: dropdownLinks.indexOf(this.state.activeLink),
        activeLinkIndex: -1,
        isHeaderOpen: false
      });
      this.closeSubNavTimeOut = setTimeout(function () {
        _this3.setState({
          isClosing: false,
          closingLinkIndex: -1,
          fixedStyles: _this3.handleCloseFixedStyles()
        });
      }, 400);
    }
  }, {
    key: 'openSubnav',
    value: function openSubnav(idxOpen) {
      var state = {
        isClosing: false,
        activeLink: dropdownLinks[idxOpen],
        activeLinkIndex: idxOpen,
        isHeaderOpen: true
      };
      if (!this.state.isOpen) {
        state.fixedStyles = false;
      }
      clearTimeout(this.closeSubNavTimeOut);
      this.setState(state);
    }
  }, {
    key: 'handleMenuButton',
    value: function handleMenuButton(event) {
      var _this4 = this;

      event.preventDefault();
      if (this.state.isOpen) {
        this.bodyRef.classList.remove(this.bodyClassNameWhenOpen, 'fixed-open');
        setTimeout(function () {
          _this4.closeHeader();
        }, 350);
      } else {
        this.bodyRef.classList.add(this.bodyClassNameWhenOpen, 'fixed-open');
        this.openHeader();
      }
    }
  }, {
    key: 'handleDelayedClose',
    value: function handleDelayedClose(delay) {
      var _this5 = this;

      this.hoverLinkTimeOut = setTimeout(function () {
        _this5.closeSubnav();
      }, delay);
    }
  }, {
    key: 'handleSubNavHover',
    value: function handleSubNavHover(event) {
      event.preventDefault();
      if (!this.state.isOpen) {
        switch (event.type) {
          case 'mouseenter':
            clearTimeout(this.hoverLinkTimeOut);
            break;
          default:
            this.handleDelayedClose(hoverCloseDelay);
            break;
        }
      }
    }
  }, {
    key: 'handleMainLinksHover',
    value: function handleMainLinksHover(event) {
      event.preventDefault();
      if (!this.state.isOpen) {
        var newIndex = dropdownLinks.indexOf(event.target);
        switch (event.type) {
          case 'mouseenter':
            clearTimeout(this.hoverLinkTimeOut);
            this.openSubnav(newIndex);
            break;
          default:
            if (this.state.activeLinkIndex !== -1) {
              this.handleDelayedClose(hoverCloseDelay);
            }
            break;
        }
      }
    }
  }, {
    key: 'handleMainLinks',
    value: function handleMainLinks(event) {
      event.preventDefault();
      var newActiveLink = this.state.activeLink !== event.currentTarget ? event.currentTarget : undefined;
      var newIndex = newActiveLink ? dropdownLinks.indexOf(event.target) : -1;
      if (newIndex !== -1) {
        this.openSubnav(newIndex);
      } else {
        this.closeSubnav(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var clickHandlers = {
        handleMenuButton: this.handleMenuButton,
        handleMainLinks: this.handleMainLinks,
        openHeader: this.openHeader,
        closeHeader: this.closeHeader,
        openSubnav: this.openSubnav,
        closeSubnav: this.closeSubnav,
        handleMainLinksHover: this.handleMainLinksHover,
        handleSubNavHover: this.handleSubNavHover
      };

      var _props = this.props,
          _props$content = _props.content,
          content = _props$content === undefined ? {} : _props$content,
          _props$config = _props.config,
          config = _props$config === undefined ? {} : _props$config;


      var fixedClasses = (0, _classnames2.default)({
        'pp-header--fixed': this.state.isHeaderFixed,
        'pp-header--sticky': this.state.isSticky,
        'pp-header--fixed-style': this.state.fixedStyles
      }, this.props.config.theme, this.props.className);

      var style = {};
      if (this.state.isSticky && this.state.isOpen) {
        style.position = 'absolute';
        style.top = this.state.scrollY;
      }

      return _react2.default.createElement(_MPPHeaderRoot2.default, {
        activeLink: this.state.activeLink,
        activeLinkIndex: this.state.activeLinkIndex,
        closingLinkIndex: this.state.closingLinkIndex,
        className: fixedClasses,
        config: config,
        content: content,
        getHeaderRef: function getHeaderRef(domNode) {
          _this6.headerRef = domNode;
        },
        handlers: clickHandlers,
        isClosing: this.state.isClosing,
        menuOpen: this.state.isOpen,
        register: this.registerDropDown,
        style: style,
        rtl: this.props.config.rtl
      });
    }
  }]);

  return GlobalHeader;
}(_react.Component);

GlobalHeader.propTypes = _MPPHeaderPropTypes2.default;

GlobalHeader.defaultProps = _MPPHeaderDefaultProps2.default;

exports.default = GlobalHeader;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/v3/GlobalHeader.js
// module id = 685
// module chunks = 4